import { useState, useEffect } from "react";
import {Link,useNavigate} from 'react-router-dom'
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemIcon
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from '@material-ui/core/styles';
import CategoryIcon from '@material-ui/icons/Category';
import HomeIcon from '@material-ui/icons/Home';
import BusinessIcon from '@material-ui/icons/Business';
import EntertainmentIcon from '@material-ui/icons/Theaters';
import HealthIcon from '@material-ui/icons/LocalHospital';
import SportsIcon from '@material-ui/icons/Sports';
//import ScienceIcon from '@material-ui/icons/Science';
import styled from '@material-ui/core/styles/styled';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import LoginScreen from "../AuthScreens/LoginScreen";
import Marquee from "./marquee";

const theme = createTheme({
  palette: {
    primary: {
      main: '#005E8F', // Change this to your desired color
    },
  },
});


const drawerWidth = 280;

const categoryIcons = {
  a: <HomeIcon />,
  b: <BusinessIcon />,
  e: <EntertainmentIcon />,
  m: <HealthIcon />,
  s: <SportsIcon />,
  // t: <ScienceIcon style={{ color: '#005E8F' }} />,
};
const useStyles = makeStyles((theme) => ({
   sticky:{
    position: 'sticky',
     top: '0px',
     zIndex: 99,

   },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,

  },
  drawerPaper: {
    width: drawerWidth,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  date: {
    fontSize: '0.8rem', // Adjust the font size as needed
    marginLeft: theme.spacing(2), // Add left margin as needed
    color: '#555', // Change text color as needed
  },
  categoryItem: {
    paddingLeft: theme.spacing(3),

  },
  categoryItemText: {
    fontFamily: 'Work Sans, sans-serif',
  },
  logoContainer: {
    backgroundColor: '#005E8F', // Blue background color
    padding: theme.spacing(1), // Add padding as needed
     width: '100%',
     height: '88px',
     display:'flex',
     alignItems:'center',
    position: 'absolute',
    top: '2%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('xs')]:{
      height: '76px',
    }
  },
  logo: {
    marginTop:'10%',
    maxWidth: '20%',
    height: 'auto', // Ensure the logo doesn't exceed its container
 
  },
 
  logoText: {
    color: 'white', // White text color
    fontSize: '1.5rem', // Adjust font size as needed
    fontFamily: 'Pacifico', // Stylish and informal script font
    letterSpacing: '2px', // Add letter spacing for a stylish touch
    textTransform: 'uppercase', // Convert text to uppercase for emphasis
    fontWeight: 'normal', // You can adjust the weight based on your preference
    textAlign: 'center', // Align text to the center
    //textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)', // Add a subtle text shadow for depth
  },
  link:{
    textDecoration:'none',
  },
   buttonStyle : {
    color: 'rgb(246, 254, 252)',
    backgroundColor: '#39927C', // You can also use the corresponding hex color
    border: '0.75px solid #39927C',
    borderRadius: '1px',
    padding: '10px 20px',
    fontSize: '14px',
    cursor: 'pointer',
    borderRadius: '8px',
    textTransform: 'none',
    whiteSpace:'nowrap',
    [theme.breakpoints.down('xs')]:{
      wordWrap:'normal',
      padding: '8px 16px',
      fontSize: '10px',
      borderRadius: '6px',
    }
  
  },
  
   signInButtonStyle : {
    textTransform: 'none',
    // new style
    color: '#39927C',
    backgroundColor: '#fff', // You can also use the corresponding hex color
    border: '0.75px solid #39927C',
    padding: '10px 20px',
    fontSize: '14px',
    cursor: 'pointer',
    borderRadius: '8px',
    textTransform: 'none',
    [theme.breakpoints.down('xs')]:{
      wordWrap:'normal',
      padding: '8px 16px',
      fontSize: '10px',
      borderRadius: '6px',
    }
    
  }
}));
const StyledListItemText = styled(ListItemText)({
  '& .MuiTypography-root': {
    fontFamily: 'Work Sans, sans-serif',
    letterSpacing: '-0.2px',
    wordBreak: 'normal',
    color: 'black', // Set the font color to white
    fontSize: '18px',
    textAlign: 'left'
    
  },
});
const StyledListItem = styled(ListItem)({
  '&:hover': {
    backgroundColor: '#89a8a0 !important', // Adding !important for specificity
  },
});

const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': {
    backgroundColor: 'white', // Set the background color here
  },
});

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Dancing Script, cursive', // Choose a stylish font, in this case, 
  width:"20%",
  fontSize: '2rem', // Adjust font size as needed
  fontWeight: 'normal', // Adjust the font weight if needed
  letterSpacing: '1px', // Add letter spacing for style
  textAlign: 'center', // Center the text
  justifyContent:'center',
  color: 'white', // Use the primary color from the theme
}));

const CustomToolBar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
});

const IconHolder = styled('div')({
  display: 'flex',
  width:"100%",
  alignItems: 'center',
  justifyContent: 'center',
});
const ButtonContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap:'2%',
  // flexDirection: 'column', // Stack buttons vertically on small screens
  '@media (min-width: 600px)': {
    flexDirection: 'row', // Switch to horizontal layout on larger screens
  },
});

const CustomButton = styled(Button)({

backgroundColor: '#39927C', /* Set your desired background color */
 color: '#39927C'/* Set your desired text color */
// cursor: pointer;


}
);


const Header = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
 const [storyData,setStoryData]=useState([])
  

  const navigate=useNavigate();
  const openLoginModal = () => {
    setLoginModalOpen(true);
  };

  const closeLoginModal = () => {
    setLoginModalOpen(false);
  };
  


  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };




  useEffect(() => {
    const getCategories = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/category/getAllCategories`);
        const fetchedStoryData = await axios
          .get(`${process.env.REACT_APP_API_URL}/story/getAllStories`)
          .then((res) => res.data.data);
  
        setStoryData(fetchedStoryData);
        setCategories(data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error (e.g., set an error state)
      }
    };
  
    getCategories();
  }, []);
  



  return (
    <div className={classes.sticky}>
      <ThemeProvider theme={theme} >
      <AppBar position='static'>
          <CustomToolBar>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>
            <IconHolder>

              <CustomTypography variant="h5" >
                  <Link to='/'> <img alt="tdh logo" src="/Logo/TDH_Logo_only.png" style={{width:'3rem'}}></img></Link>
              </CustomTypography>
            </IconHolder>
      
          </CustomToolBar>
        </AppBar>
      </ThemeProvider>
      <Marquee currentContent={storyData}/>
      <StyledDrawer
        className={classes.drawer}
        variant="temporary"
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.toolbar}>
          {/* Logo or text on the top left */}
          <div className={classes.logoContainer}>
            <div className={classes.logoText}><Link to='/'><img src='/Logo/TDH_Logo_only.png' className={classes.logo}></img></Link></div>
            {/* TD.HUB */}
          </div>
        
         
        </div>
        <List>
          
          {categories.map((category) => (
           
            <Link to={'/category-details'} state={{ name: category.name }} className={classes.link}>
            <StyledListItem onClick={handleDrawerClose} key={category._id} className={classes.categoryItem}>
              <ListItemIcon>
                {categoryIcons[category.google_short_code] || <CategoryIcon />}
              </ListItemIcon>
              <StyledListItemText primary={category.name} />
            </StyledListItem>
            </Link>
          ))} 
        </List>

        <Divider />
        {/* Additional sections can be added here */}
      </StyledDrawer>
    </div>
  );
};

export default Header;
